import { useState } from 'react';
import { Modal } from 'react-bootstrap';

/**
 * Reusable trigger + popup image viewer for inline "more info" patterns.
 */
export default function ImageInfoPopup({
  triggerLabel = 'More info',
  imageSrc,
  imageAlt = 'More information',
  buttonClassName = '',
  disabled = false,
}) {
  const [isOpen, setIsOpen] = useState(false);

  if (!imageSrc) return null;

  return (
    <>
      <button
        type="button"
        className={`border-0 bg-transparent p-0 text-decoration-underline fw-semibold text-primary ${buttonClassName}`.trim()}
        onClick={() => setIsOpen(true)}
        disabled={disabled}
        aria-haspopup="dialog"
        aria-label={triggerLabel}
      >
        {triggerLabel}
      </button>

      <Modal
        centered
        show={isOpen}
        onHide={() => setIsOpen(false)}
        size="lg"
        backdrop="static"
        className="!z-[11000]"
        backdropClassName="!z-[10990] !bg-black"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-6 fw-semibold">{imageAlt}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2 p-md-3">
          <img src={imageSrc} alt={imageAlt} className="w-100 h-auto rounded" />
        </Modal.Body>
      </Modal>
    </>
  );
}
